export default __webpack_public_path__ + "64f0f45341f315f396dafc5e6306760b.png";